import {
  getAllocationDatas,
  setAllocationForm,
  getAllocationListDatas,
  editAllocation,
  delAllocation,
  editMethod,
  openShare,
  closeShare
} from '@/services/config'
import {
  getGroupMembers
} from '@/services/team'
import { getAuthTeamInfo } from '@/services/index'
import i18n from '@/lib/language'
export default {
  namespaced: true,
  state: {
    submitting: false,
    datasReady: false,
    listDatasReady: false,
    allDatas: [],
    selectedDatas: [],
    listDatas: [],
    allListDataObj: {},
    activeName: 'setmethod',
    teamData: [],
    teamData2: []
  },
  mutations: {
    // 设置数据容器的值
    setAllDatas (state, datas) {
      state.allDatas = datas
    },
    setSelectedDatas (state, datas) {
      state.selectedDatas = datas
    },
    // setListDatas (state, datas) {
    //   state.listDatas = datas
    // },
    setDatasReady (state, b) {
      state.datasReady = b
    },
    setListDatasReady (state, b) {
      state.listDatasReady = b
    },
    setActiveName (state, name) {
      state.activeName = name
    },
    setAllListDataObj (state, data) {
      state.allListDataObj = data
    },
    setTeamData (state, data) {
      state.teamData = data
    },
    setTeamData2 (state, data) {
      state.teamData2 = data
    }
  },
  getters: {
    datas (state) {
      const { selectedDatas = [], allDatas = [] } = state
      selectedDatas.forEach((item) => {
        for (let i = 0; i < allDatas.length; i++) {
          if (item.fieldkey === allDatas[i].fieldkey) {
            allDatas[i].isSelected = true
            return false
          }
        }
      })

      return allDatas
    },
    lists (state) {
      const { allListDataObj = {} } = state
      const { rule = [] } = allListDataObj
      rule.forEach(item => {
        item.key = item.id
      })
      return rule
    },
    wayLists (state) {
      const { allListDataObj = {} } = state
      const { way = [] } = allListDataObj

      way.forEach(item => {
        item.key = item.groupid
      })
      return way
    },
    editSelectedDatas (state) {
      const { selectedDatas = [] } = state
      selectedDatas.forEach(item => {
        if (item.fieldtype !== 'area' && item.options.length) {
          if (item.options.every(item => item.id !== 0)) {
            item.options.unshift({ id: 0, name: '-' + i18n.t('message["574"]') + '-' })
          }
        }
      })
      return selectedDatas
    },
    currentDevelopDatas (state) {
      const { teamData = [] } = state
      function dataLoop (arr, pid) {
        arr.forEach((item, index) => {
          item.value = item.id + item.keyname
          item.label = item.name
          // item.title = item.name
          item.key = item.id
          item['pid'] = pid
          if (item.pid) {
            item.key = pid + '-' + item.id
          } else {
            item.key = item.id
          }
          if (item.children && item.children.length) {
            dataLoop(item.children, item.id)
          }
        })
      }
      dataLoop(teamData, null)
      // state.developDatasReady = true
      return teamData || []
    },
    currentDevelopDatas2 (state) {
      const { teamData2 } = state
      function dataLoop (arr, pid) {
        arr.forEach((item, index) => {
          item.value = item.keyname + '-' + item.id
          item.label = item.name
          // item.title = item.name
          item.key = item.id
          item['pid'] = pid
          if (item.pid) {
            item.key = pid + '-' + item.id
          } else {
            item.key = item.id
          }
          if (item.children && item.children.length) {
            dataLoop(item.children, item.id)
          }
        })
      }
      dataLoop(teamData2, null)
      // state.developDatasReady = true
      return teamData2 || []
    }
  },
  actions: {
    async fetchAllocationDatas ({ commit }) {
      const chain = await getAllocationDatas()
        .onSuccess((raw) => {
          commit('setAllDatas', raw.all)
          commit('setSelectedDatas', raw.select)
          commit('setDatasReady', true)
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async setAllocationForm ({ commit, dispatch }) {
      const chain = await setAllocationForm()
        .onSuccess(async (raw) => {
          const chain2 = await dispatch('fetchAllocationDatas')
          chain2.fetch()
          const chain3 = await dispatch('fetchAllocationListDatas')
          chain3.fetch()
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async fetchAllocationListDatas ({ state, commit }) {
      const chain = await getAllocationListDatas()
        .onSuccess((raw) => {
          commit('setAllListDataObj', raw)
          commit('setListDatasReady', true)
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async delAllocation ({ commit, dispatch }) {
      const chain = await delAllocation()
        .onSuccess(async (raw) => {
          const chain2 = await dispatch('fetchAllocationListDatas')
          chain2.fetch()
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async editAllocation ({ commit, dispatch }) {
      const chain = await editAllocation()
        .onSuccess(async (raw) => {
          const chain2 = await dispatch('fetchAllocationListDatas')
          chain2.fetch()
        })
        .onNetComplete(() => {
        })
        .config({ tip: false, warn: false })
      return chain
    },
    async getGroupMembers ({ commit, dispatch }) {
      const chain = await getGroupMembers()
        .onSuccess(async (raw) => {
        })
        .onNetComplete(() => {
        })
        .config({ tip: false, warn: false })
      return chain
    },
    async editMethod ({ commit, dispatch }) {
      const chain = await editMethod()
        .onSuccess(async (raw) => {
          const chain2 = await dispatch('fetchAllocationListDatas')
          chain2.fetch()
        })
        .onNetComplete(() => {
        })
        .config({ tip: false })
      return chain
    },
    async getAuthTeamInfo ({ commit, dispatch }) {
      const chain = await getAuthTeamInfo()
        .params({ pk: 'inquiry-followup', type: 1 })
        .onSuccess(async (raw) => {
          commit('setTeamData', raw)
        })
        .onNetComplete(() => {
        })
        .config({ tip: false, warn: false })
        .fetch()
      return chain
    },
    async getAuthTeamInfo2 ({ commit, dispatch }) {
      const chain = await getAuthTeamInfo()
        .params({ pk: 'inquiry-followup', type: 0, divide: 1, deal: 1 })
        .onSuccess(async (raw) => {
          commit('setTeamData2', raw)
        })
        .onNetComplete(() => {
        })
        .config({ tip: false, warn: false })
        .fetch()
      return chain
    },
    /* 是否开启共享 */
    async setIsShare ({ commit }, isShare) {
      let chain
      if (isShare) {
        chain = await openShare()
      } else {
        chain = await closeShare()
      }
      chain
        .onSuccess((raw) => {})
        .fetch()
      return chain
    }
  }
}
